import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Detail_3({ item, isSub }) {
  //const isHtml = item.scale.isHtml;
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  return (
    <Row
      className={"justify-content-center align-content-start"}
      style={{ height: Number(item?.height), marginBottom: "6px" }}
    >
      {!isSub && (
        <Row className={"justify-content-center "} style={{ height: "fit-content", fontSize: 15, fontWeight: 700 }}>
          {item.scopeName}
        </Row>
      )}

      <div className={"py-3 rounded-4 px-4"} style={{ backgroundColor: isSub ? "white" : "#0048aa" }}>
        <Row>
          <Col className={"align-content-center"}>
            {isSub && <Row className={"detail-scope-name-blurred mb-2 px-3"}>{item.scopeName}</Row>}
            <Row style={{ color: !isSub ? "white" : "" }} className={"main-scope-name-detail-pdf-new px-3 pb-2"}>
              {item.name}
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className={"align-content-center _scale-detail-text-pdf-new "} xs={5}>
            <div
              style={{ color: !isSub ? "white" : "" }}
              dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
            ></div>
          </Col>

          <Col xs={7} className={"align-content-center"}>
            <Row
              className={"justify-content-between mt-1 round-40px border border-2"}
              style={{ borderColor: "#A6D1FF", padding: "0px 5px" }}
            >
              {item.scale.ranges.map((range, i) => {
                const isLast = item.scale.ranges.length - 1 === i;
                const isFirst = i === 0;

                let margins = {
                  cubeMargin: "0%",
                  textMargin: "50%",
                };
                if (isFirst) {
                  margins.cubeMargin = "-25%";
                  margins.textMargin = "75%";
                }
                if (isLast) {
                  margins.cubeMargin = "25%";
                  margins.textMargin = "25%";
                }
                if (range.isHit === true) {
                  return (
                    <Col key={i} xs={"auto"} className={"align-content-center position-relative p-0"}>
                      <Row
                        className={"position-absolute translate-middle-x mx-0"}
                        style={{ top: "-25px", left: "50%" }}
                      >
                        <Col
                          xs={"auto"}
                          className={"position-relative px-0"}
                          style={{ marginLeft: margins.textMargin }}
                        >
                          <div
                            className={" z-0  rotated-div-cube  "}
                            style={{
                              marginTop: 12,
                              height: 10,
                              width: 10,
                              marginLeft: margins.cubeMargin,
                              backgroundColor: isSub ? "#007aff" : "#fff5ce",
                            }}
                          ></div>
                          <div
                            className={" px-2 z-1  detail-hit-range-name-above-pdf translate-middle-x text-nowrap"}
                            style={{
                              marginTop: -22,
                              fontSize: 12,
                              backgroundColor: isSub ? "#007aff" : "#fff5ce",
                              color: isSub ? "white" : "#00428a",
                            }}
                          >
                            {range.text}
                          </div>
                        </Col>
                      </Row>
                      <div
                        className={"hit-scale-style-variable-opacity-pdf-round p-0 _flex-center"}
                        style={{ margin: "2px -3px" }}
                      >
                        {elementScore}
                      </div>
                    </Col>
                  );
                } else {
                  return (
                    <Col key={i} xs={"auto"} className={"align-content-center p-0"}>
                      <div
                        style={{
                          backgroundColor: "white",
                          width: "fit-content",
                          height: "fit-content",
                          borderRadius: "50%",
                          padding: 0,
                        }}
                      >
                        <div
                          className={"scale-style-variable-opacity-pdf-round p-0"}
                          style={{
                            opacity: (i + 1) * (1 / item.scale.ranges.length),
                            backgroundColor: isSub ? "#00428a" : "#02a4ff",
                          }}
                        ></div>
                      </div>
                    </Col>
                  );
                }
              })}
            </Row>
          </Col>
        </Row>
      </div>
    </Row>
  );
}
